import { render, staticRenderFns } from "./LiveDwellings.vue?vue&type=template&id=ba01c7f6&"
import script from "./LiveDwellings.vue?vue&type=script&lang=js&"
export * from "./LiveDwellings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports